import { BackendHttpService } from './backendHttpService';

export interface BenchImportRowResult {
    rowNumber: number;
    identifier: string;
    status: 'Updated' | 'Cleared' | 'AmbiguousName' | 'NotFound' | 'NotPermitted' | 'NoIdentifier' | 'ParseError';
    personId: number | null;
    matches: string[];
    detail: string;
}

export interface BenchImportResult {
    updatedCount: number;
    rows: BenchImportRowResult[];
}

export class BenchImportService extends BackendHttpService {
    constructor() {
        super('bench-import');
    }

    async importFile(file: File): Promise<BenchImportResult> {
        const formData = new FormData();
        formData.append('file', file);
        return this.postFormData<FormData, BenchImportResult>(formData);
    }
}

export const benchImportService = new BenchImportService();
